import React, { useState } from 'react';
const faqs = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: 'En el momento en que confirmás el pago recibís un mail con el acceso a todos los materiales. No hay espera, no hay envío físico. Todo es digital y lo podés abrir desde el celular, la tablet o la computadora en menos de 5 minutos.'
}, {
  question: '¿Sirve si trabajo sola en gabinete privado o solo para centros?',
  answer: 'Está pensado principalmente para profesionales independientes que trabajan solas o en gabinete pequeño. Todo el sistema de cobro, informes y seguimiento está diseñado para que lo manejés vos sin depender de nadie más. Si trabajás en un centro también lo podés aplicar, pero el foco es la práctica autogestionada.'
}, {
  question: '¿Los materiales son editables?',
  answer: 'Sí. Los documentos vienen en formatos editables para que puedas poner tu nombre, logo y datos. Los checklists, informes y contratos son tuyos para personalizar como necesites.'
}, {
  question: '¿Los 6 bonos están incluidos en las dos opciones?',
  answer: 'Los 6 bonos están incluidos en el Combo Completo. La opción estándar incluye los 6 tomos del Megapack. Si querés el sistema completo — con el Método Integral, los documentos legales y el calendario de contenido — el Combo es la opción más inteligente.'
}, {
  question: '¿Sirve si soy recién recibida con poca experiencia?',
  answer: 'Es ideal para eso. Todo está explicado con criterio clínico pero en lenguaje claro y aplicable desde el primer día. No asume que ya sabés todo — te da el marco para trabajar con seguridad aunque estés empezando a construir tu práctica.'
}, {
  question: '¿Funciona para bebés de todas las edades?',
  answer: 'Sí. Los 6 tomos están organizados por franjas etarias desde los 0 hasta los 36 meses. Cada tomo tiene las sesiones, los hitos esperados y las alertas específicas para esa etapa. No es contenido genérico — es por edad y por área de desarrollo.'
}, {
  question: '¿Qué pasa si atiendo niños con diagnóstico o en evaluación?',
  answer: 'El Tomo 4 tiene el semáforo de alertas y los criterios de derivación. No reemplaza el juicio clínico, pero te da un marco estructurado para identificar señales, documentarlas y hablar con las familias con seguridad. Muchas profesionales lo usan exactamente en esos casos.'
}, {
  question: '¿Qué diferencia tiene con otros materiales de ET del mercado?',
  answer: 'La mayoría de los materiales que existen son teóricos o están pensados para la formación académica. Este sistema está diseñado para la práctica real: sesiones planificadas, documentos para usar con familias, sistema de cobro, retención y comunicación. No es un libro — es una caja de herramientas lista para trabajar.'
}, {
  question: '¿Por qué elegir el Combo Completo y no el estándar?',
  answer: 'El Megapack te da el sistema clínico. El Combo Completo le agrega el sistema de negocio: cómo cobrar, cómo retener familias, cómo construir autoridad en redes y cómo manejar situaciones difíciles. Si querés trabajar mejor, el Megapack alcanza. Si querés además crecer como profesional y ganar lo que merecés, el Combo es la decisión obvia.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Tenés 7 días desde el momento de la compra para revisarlo todo. Si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas, sin formularios y sin drama. La tasa de devolución es menor al 1% — no porque no se pueda pedir, sino porque el material habla por sí solo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(224,242,254) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-142">
      <div className="mx-auto max-w-3xl" data-id="element-143">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-144">
          Preguntas <span className="text-cyan-brand" data-id="element-145">frecuentes</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-146">
          Todo lo que necesitás saber antes de decidir.
        </p>

        {/* Accordion */}
        <div className="flex flex-col gap-2" data-id="element-147">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-xl overflow-hidden shadow-sm transition-all" style={{
            border: isOpen ? '1px solid rgba(0, 180, 216, 0.5)' : '1px solid rgba(0, 180, 216, 0.15)'
          }} data-id="element-148">
                {/* Question */}
                <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-5 py-4 m-0" style={{
              fontFamily: 'inherit'
            }} data-id="element-149">
                  <span className="text-sm font-bold" style={{
                color: isOpen ? '#00b4d8' : '#111827'
              }} data-id="element-150">
                    {i + 1}. {faq.question}
                  </span>
                  <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-white text-base font-black transition-transform duration-300" style={{
                backgroundColor: '#00b4d8',
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
              }} data-id="element-151">
                    +
                  </span>
                </button>

                {/* Answer */}
                {isOpen && <div className="px-5 pb-4" style={{
              borderTop: '1px solid rgba(0, 180, 216, 0.1)'
            }} data-id="element-152">
                    <p className="text-sm text-gray-600 leading-relaxed m-0 pt-3" data-id="element-153">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}